export default "__VITE_ASSET__CHQgaIkr__"